import type { TNAPIBody, TNAPIQuery } from '~/types/napi-helpers'

function createPost(data: TNAPIBody<'/napis/v1/discussion/post/', 'post'>) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/post/'
  const method = 'post'
  const param = undefined
  const query = undefined

  return openAPIFetchOnce(path, method, param, query, data)
}

function updatePost(
  postIdSlug: string,
  data: TNAPIBody<'/napis/v1/discussion/post/{post_id_slug}/', 'patch'>
) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/post/{post_id_slug}/'
  const method = 'patch'
  const param = {
    post_id_slug: postIdSlug
  }
  const query = undefined

  return openAPIFetchOnce(path, method, param, query, data)
}

function deletePost(postIdSlug: string) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/post/{post_id_slug}/'
  const method = 'delete'
  const param = {
    post_id_slug: postIdSlug
  }
  const query = undefined

  return openAPIFetchOnce(path, method, param, query)
}

function deletePostImage(postIdSlug: string, postFileIdSlug: string) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/post/{post_id_slug}/post-file/{file_id_slug}/'
  const method = 'delete'
  const param = {
    post_id_slug: postIdSlug,
    file_id_slug: postFileIdSlug
  }
  const query = undefined

  return openAPIFetchOnce(path, method, param, query)
}

function listPostsReactive(
  query: TNAPIQuery<'/napis/v1/discussion/posts/', 'get'>,
  asyncDataOptions: Record<string, any> = {}
) {
  const { openApiReactiveGet } = useAuthFetch()
  return openApiReactiveGet('/napis/v1/discussion/posts/', undefined, query, asyncDataOptions)
}

function getPost(postIdSlug: string) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/post/{post_id_slug}/'
  const method = 'get'
  const param = {
    post_id_slug: postIdSlug
  }
  const query = undefined

  return openAPIFetchOnce(path, method, param, query)
}

function getClassPosts(
  classroomTagSlugName: string,
  query: TNAPIQuery<'/napis/v1/discussion/posts/classroom/{classroom_tag_slug_name}/feed/', 'get'>,
  asyncDataOptions: Record<string, any> = {}
) {
  const { openApiReactiveGet } = useAuthFetch()
  const param = {
    classroom_tag_slug_name: classroomTagSlugName
  }
  return openApiReactiveGet(
    '/napis/v1/discussion/posts/classroom/{classroom_tag_slug_name}/feed/',
    param,
    query,
    asyncDataOptions
  )
}

function getPostsByTagSlugName(
  tagSlugName: string,
  query: TNAPIQuery<'/napis/v1/discussion/tags/{tag_slug_name}/posts/', 'get'>,
  asyncDataOptions: Record<string, any> = {}
) {
  const { openApiReactiveGet } = useAuthFetch()
  const param = {
    tag_slug_name: tagSlugName
  }
  return openApiReactiveGet(
    '/napis/v1/discussion/tags/{tag_slug_name}/posts/',
    param,
    query,
    asyncDataOptions
  )
}

function listSupportPostsReactive(
  query: TNAPIQuery<'/napis/v1/discussion/support-posts/', 'get'>,
  asyncDataOptions: Record<string, any> = {}
) {
  const { openApiReactiveGet } = useAuthFetch()
  return openApiReactiveGet(
    '/napis/v1/discussion/support-posts/',
    undefined,
    query,
    asyncDataOptions
  )
}

type useForumPostReturnType = {
  createPost: typeof createPost
  updatePost: typeof updatePost
  deletePost: typeof deletePost
  deletePostImage: typeof deletePostImage
  listPostsReactive: typeof listPostsReactive
  getPost: typeof getPost
  getClassPosts: typeof getClassPosts
  getPostsByTagSlugName: typeof getPostsByTagSlugName
  listSupportPostsReactive: typeof listSupportPostsReactive
}

export function useForumPost(): useForumPostReturnType {
  return {
    createPost,
    updatePost,
    deletePost,
    deletePostImage,
    listPostsReactive,
    getPost,
    getClassPosts,
    getPostsByTagSlugName,
    listSupportPostsReactive
  }
}
